import { encode as encodeBase58 } from "../util/base58";

const KEY_ITEM_CLASS = 1;
const KEY_ATTRIBUTE = 2;
const KEY_STYLE = 3;
const KEY_COLOUR_SCALE = 4;
const KEY_RANGE_MIN = 5;
const KEY_RANGE_MAX = 6;
	
// Java by default is big endian
const LITTLE_ENDIAN = false;

const appendTo = (source, target, offset) => {
	const sourceArray = new Uint8Array(source);
	const targetArray = new Uint8Array(target);

	for( let i = 0; i < sourceArray.byteLength; i++) {
		targetArray[i + offset] = sourceArray[i];
	}	
}


class StyleEncoder {
	
	constructor(type) {
		this.buffer = undefined;
		this.readableBuffer = {};
		this.position = 0;
	}
	
	append(newBuffer) {
		if( this.buffer ) {
			const position = this.buffer.byteLength;
			
			const nextBuffer = new ArrayBuffer(position + newBuffer.byteLength)
			appendTo(this.buffer, nextBuffer, 0);		
			appendTo(newBuffer, nextBuffer, this.buffer.byteLength);
			
			this.buffer = nextBuffer;
		} else {
			this.buffer = newBuffer;
		}
	}
	
	
	writeLong(key, value){		
		const buffer = new ArrayBuffer(4);
		new DataView(buffer).setUint32(0, value, LITTLE_ENDIAN);

		return this.writeKey(key, buffer, value);
	}
	
	writeDouble(key, value){		
		const buffer = new ArrayBuffer(4);
		new DataView(buffer).setFloat32(0, value, LITTLE_ENDIAN);

		return this.writeKey(key, buffer, value);
	}
	
	writeKey(key, buffer, value) {
		this.readableBuffer[key] = value;
		
		const nextBuffer = new ArrayBuffer(5);
		const target = new Uint8Array(nextBuffer);
		target[0] = key;
		
		appendTo(buffer, nextBuffer, 1);		
		this.append(nextBuffer);
		
		return this;
	}
	
	withStyle(style) {
		return this.writeLong(KEY_STYLE, style);
	}
	
	withItemClass(itemClass) {
		return this.writeLong(KEY_ITEM_CLASS, itemClass);
	}
	
	withColourScale(colourScale) {
		return this.writeLong(KEY_COLOUR_SCALE, colourScale);
	}
	
	withAttribute(attribute) {
		return this.writeLong(KEY_ATTRIBUTE, attribute);
	}
	
	withRangeMin(min) {
		return this.writeDouble(KEY_RANGE_MIN, min);
	}
	
	withRangeMax(max) {
		return this.writeDouble(KEY_RANGE_MAX, max);
	}	
	
	asString() {
		return encodeBase58(this.buffer);
	}	
	
}

export { 
	StyleEncoder
}